

function handleProductRecomendations() {
  if (0 < $("#would_like_too .product-recommendations").length) {
    let a = document.querySelector("#would_like_too .product-recommendations");
    new IntersectionObserver(
      (e, t) => {
        e[0].isIntersecting &&
          (t.unobserve(a),
          (e = a.dataset.url),
          fetch(e)
            .then((e) => e.text())
            .then((e) => {
              var t = document.createElement("div"), e = ((t.innerHTML = e), t.querySelector("#would_like_too .product-recommendations"));
              e && e.innerHTML.trim().length && ((a.innerHTML = e.innerHTML), createCollectionSwiper("would_like_too"), formatStarInKitShelf());
              $(".jdgm-prev-badge__stars").each((idx,el) => {
                const prevScore  = $(el).data("score").toString();
                const newScore = prevScore.replace('.',',');
                $(el).attr('data-score',newScore)
              });
              $(".total-stars-custom p").each((idx,el) => {
                const prevScore = $(el).html().toString().replace('.',',');
                $(el).html(prevScore)
              })
            })
            .catch((e) => {
              console.error(e);
            }));
      },
      { rootMargin: "0px 0px 200px 0px" }
    ).observe(a);
  }
}

function formatTopKitStars() {
  var e = document.querySelectorAll(".ratings-kit .jdgm-prev-badge");
  let a = 0,
    n = 0;
  Array.from(e).forEach((e) => {
    var t = parseFloat(e.getAttribute("data-average-rating")) || 0,
      e = parseInt(e.getAttribute("data-number-of-reviews")) || 0;
    (a += t * e), (n += e);
  }),
    createStarRating((0 < n ? a / n : 0).toFixed(2));
}

function createStarRating(e) {
  var t = Math.floor(e),
      a = 0.1 <= e % 1 && e % 1 <= 0.9,
      n = document.createElement("div"),
      r = document.createElement("p");
  r.className = "stars-rating";
  (r.innerHTML = e), (n.className = "custom-kit-stars");
  for (let e = 0; e < t; e++) {
    var i = document.createElement("span");
    (i.className = "jdgm-star jdgm--on"), n.appendChild(i);
  }
  a && (((e = document.createElement("span")).className = "jdgm-star jdgm--half"), n.appendChild(e));
  var o = 5 - t - (a ? 1 : 0);
  for (let e = 0; e < o; e++) {
    var s = document.createElement("span");
    (s.className = "jdgm-star jdgm--off"), n.appendChild(s);
  }
  document.querySelector(".ratings-kit").appendChild(n),
  document.querySelector(".ratings-kit").appendChild(r);
}

function observerReviews() {
  var e = $(".jdgm-rev-widg__body");
  e.find(".jdgm--done-setup") &&
    new MutationObserver(function (e, t) {
      let a = !1;
      for (var n of e)
        "childList" !== n.type || a || (redefineDomReviews(), scrollToSection(), (a = !0));
    }).observe(e[0], { childList: !0, subtree: !0 });
}

function redefineDomReviews() {
  $(".jdgm-rev.jdgm-divider-top.jdgm--done-setup").each((e, t) => {
    $(t).hasClass("formatted") ||
      (redefineUSerNameAndDate(t), $(t).addClass("formatted"));
  });
}

function redefineUSerNameAndDate(e) {
  var t = $(e).find(".jdgm-rev__author-wrapper"),
    a = $(e).find(".jdgm-rev__timestamp"),
    e = $(e).find(".jdgm-rev__content"),
    n = $('<div class="wrapper-name-date"></div>');
  n.append(t), n.append(a), e.append(n);
}




function formattDate(e) {
  $(e).html(function (e, t) {
    var t = t.split("/"),
      a = t[0],
      t = new Date(t[2], t[1], a);
    return `
            <span>${t.getDay()}</span>
            de 
            <span>${t
              .toLocaleString("default", { month: "short" })
              .replace(".", "")}</span>
            de 
            <span>${t.getFullYear()}</span>
          `;
  });
}

$(function () {
    const intervalRatings = setInterval(() => {
      if($("#reviews-ratings .media-review").length > 0) {
        clearInterval(intervalRatings);
        const rating =$(".ratings-kit .stars-rating").html();
        $("#reviews-ratings .media-review").append($(`<span>${rating}</span>`));
      }
    },1000)

    let count = 0;

    const intervalR = setInterval(() => {
      if($(".stars-rating").length > 0) {
        clearInterval(intervalR);
          const startText = $(".stars-rating").html();
          $(".stars-rating").html(startText.replace(".", ","));
      }
      if(count == 10) {
          clearInterval(intervalR);
      }
      count+= 1;
    },500)

  setTimeout(() => {
  let count2 = 0;
  const intervalR2 = setInterval(() => {
     console.log($(".media-review"));
      if($(".media-review").length > 0) {
          const startText = $(".media-review").html().replace(".", ",");
          $(".media-review").html(startText);
        clearInterval(intervalR2);
      }
    if(count2 == 10) {
        clearInterval(intervalR2);
    }  
    count2+= 1;
  },500)
},1500)

  let count2 = 0;
  const intervalR2 = setInterval(() => {
      if($(".media-review").length > 0) {
        const startText = $(".media-review").html();
        $(".media-review").html(startText.replace(".", ",") );
        clearInterval(intervalR2);
        const startText2 = $(".media-review").html();
        $(".media-review").html(startText2.replace(".", ",") );
      }
    if(count2 == 10) {
      clearInterval(intervalR2);
    }  
    count2+= 1;
  },500)

  let count3 = 0;
  const intervalR3 = setInterval(() => {
    if($(".jdgm-link").length > 0) {
      clearInterval(intervalR3);
      const startText = $(".jdgm-link").html();
      $(".jdgm-link").html(startText.replace(".", ",") );
    }
    if(count3 == 10) {
      clearInterval(intervalR3);
    }  
    count3+= 1;
  },500)
  
  handleProductRecomendations(),
    document.querySelector(".reviews-ratings-kits") &&
      (getAllReviewsOfProducts(), formatTopKitStars()),
    1024 <= $(window).width() &&
      0 < $("#product-main-image").length &&
      $("#product-main-image").elevateZoom({
        zoomType: "lens",
        borderSize: 2,
        containLensZoom: !0,
        lensShape: "round",
        borderColour: "#890D47",
        cursor: "crosshair",
        lensSize: 300,
      });
  new Swiper(".mySwiper", {
    autoplay: { delay: 3e3, disableOnInteraction: !1 },
    loop: !0,
    pagination: {
      el: ".swiper-pagination",
      clickable: !0,
      renderBullet: function (e, t) {
        return '<span class="' + t + '"></span>';
      },
    },
  });
  let e = setInterval(() => {
      0 < $(".stars-media >div").length && clearInterval(e);
    }, 1e3),
    t = setInterval(() => {
      let a = $(".jdgm-write-rev-link");
      0 < a.length &&
        (clearInterval(t),
        a[0].click(),
        setTimeout(() => {
          let e = $(".jdgm-form-wrapper"),
            t = $('<a class="jdgm-write-rev-link">Escreva uma avaliação</a>');
          t.attr("style", "cursor:pointer; text-align:center"),
            t.addClass("custom-btn"),
            a.parent().append(t),
            a.remove(),
            t.on("click", function () {
              e.toggle(300, function () {
                e.is(":visible")
                  ? t.html("Cancelar sua avaliação")
                  : t.html("Escreva uma avaliação");
              });
            }),
            0 < $(".jdgm-paginate__page").length &&
              $(".jdgm-paginate__page").on("click", function (e) {
                setTimeout(() => {
                  $("html, body").animate(
                    { scrollTop: $("#reviews-ratings").offset().top },
                    1e3
                  );
                }, 500);
              });
        }, 1e3),
        observerReviews(),
        redefineDomReviews());
    }, 1e3),
    a = setInterval(() => {
      0 < $(".jdgm-rev-widg__summary-average").length &&
        (clearInterval(a),
        $(".jdgm-rev-widg__summary-average").html(function (e, t) {
          return t.split("de")[0];
        }));
    }, 1e3);


});

function scrollToSection() {
  0 < $(".jdgm-paginate__page").length &&
    $(".jdgm-paginate__page").on("click", function (e) {
      setTimeout(() => {
        $("html, body").animate(
          { scrollTop: $("#reviews-ratings").offset().top },
          1e3
        );
      }, 500);
    });
}

let getAllReviewsOfProducts = () => {
  let a = [];
  $(".kit-card-list .element-kit").each((e, t) => a.push($(t).data("url")));
  var e = a.map((e) => getKitItemData(e));
  Promise.all(e)
    .then(async (e) => {
      await createReviewBox(e),
        await formatKitReviewsDate(),
        await calcKitReviewsValue(),
        redefineDomReviews();
    })
    .catch((e) => {
      console.error(e);
    });
};

async function getKitItemData(e) {
  return await (await fetch("https://vinsel.com.br/products/" + e)).text();
}

async function createReviewBox(e) {
  e.forEach((e, t) => {
    var a = document.createElement("div"),
      e =
        ((a.innerHTML = e),
        a.querySelector(".jdgm-rev-widg__reviews").innerHTML);
    $("#reviews-ratings .container .jdgm-rev-widg__body").append(e),
      $(".jdgm-rev").addClass("jdgm--done-setup");
  });
}

async function formatKitReviewsDate() {
  $(".jdgm-rev__timestamp").each((e, t) => {
    var a;
    $(t).hasClass("date--formatted") ||
      ((a =
        (a = $(t).data("content").split(" ")[0].split("-"))[2] +
        `/${a[1]}/` +
        a[0]),
      $(t).html(a),
      $(t).removeClass("jdgm-spinner"),
      $(t).addClass("date--formatted"));
  });
}

async function calcKitReviewsValue() {
  var { qtd: e, media: t } = await calcReviewsValues(),
    e =
      ($(".media-review").html(t),
      $(".op-number").html(e),
      createArrayStars(t));
  createStarElement(e);
}

async function calcReviewsValues() {
  let a = [];
  $(".jdgm-rev__rating").each((e, t) => a.push($(t).data("score")));
  var e = a.length,
    t = a.reduce((e, t) => e + t, 0);
  return { qtd: e, total: t, media: (t / e).toFixed(2) };
}

function createArrayStars(t) {
  var a = [];
  for (let e = 1; e <= 5; e++)
    e <= Math.floor(t)
      ? a.push("jdgm--on")
      : e === Math.ceil(t)
      ? a.push("jdgm--half")
      : a.push("jdgm--off");
  return a;
}

function createStarElement(e) {
  let t = $(".stars-media div");
  e.forEach((e) => {
    e = $(`<span class="jdgm-star ${e}"></span>`);
    t.append(e);
  });
}
